export class CopyTransactionFunctionalAnalysisPayload {
  resourceName: string;
  resourceId: number;
  type: number;
  analysisName: string;
}
